module.exports = __webpack_public_path__ + "img/reward-box02-sp.c91531d0.png";